export const eventLogConfig: any[] = [
    {
        title: 'Id',
        field: 'id',
        fitWidth: true,
    },
    {
        title: "Create Date",
        field: "createDate"
    },
    {
        title: 'Account Id',
        field: 'accountId',
    },
    {
        title: 'Display Name',
        field: 'displayName',
    },
    {
        title: 'Message',
        field: 'message',
    },
    {
        title: 'Ip Address',
        field: 'ipAddress',
    },
    {
        title: "Browser",
        field: "browser"
    }
];

export const errorLogConfig: any[] = [
    {
        title: 'Id',
        field: 'id',
        fitWidth: true,
    },
    {
        title: "Create Date",
        field: "createDate"
    },
    {
        title: 'Account Id',
        field: 'accountId',
    },
    {
        title: 'Source Function',
        field: 'sourceFunction',
    },
    {
        title: 'Description',
        field: 'description',
    }
];
